import { useDispatch, useSelector } from 'react-redux';

import {
  setRecommendationsAction,
  clearRecommendationsAction,
  setRecommendationsDetailsAction,
  clearRecommendationsDetailsAction,
  getRecommendationsService,
} from 'features/recommendations/redux/slice';

import {
  UseRecommendationsState,
  RecommendationsApiResponse,
  RecommendationsDetailsApiResponse,
} from './types';

const useRecommendations = (): UseRecommendationsState => {
  const recommendations = useSelector(getRecommendationsService);

  const dispatch = useDispatch();

  const setRecommendations = (receivedRecommendations: RecommendationsApiResponse) => {
    dispatch(setRecommendationsAction(receivedRecommendations));
  };

  const clearRecommendations = () => {
    dispatch(clearRecommendationsAction());
  };

  const setRecommendationsDetails = (
    receivedRecommendationsDetails: RecommendationsDetailsApiResponse
  ) => {
    dispatch(setRecommendationsDetailsAction(receivedRecommendationsDetails));
  };

  const clearRecommendationsDetails = () => {
    dispatch(clearRecommendationsDetailsAction());
  };

  return {
    ...recommendations,
    setRecommendations,
    clearRecommendations,
    setRecommendationsDetails,
    clearRecommendationsDetails,
  };
};

export default useRecommendations;
